import { render, staticRenderFns } from "./SendSmsList.vue?vue&type=template&id=688d679c"
import script from "./SendSmsList.vue?vue&type=script&lang=js"
export * from "./SendSmsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports